export default __webpack_public_path__ + "fonts/banner-font.5a7cf111f54ac83b40b3baeb843b33f2.jpg";